import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about-page',
  imports: [],
  templateUrl: './about-page.html',
  styleUrl: './about-page.css'
})
export class AboutPage {
  constructor(private router: Router) { }

  navigateAndScroll(route: string, x: number = 0, y: number = 0) {
    this.router.navigate([route]).then(() => {
      window.scrollTo(x, y);
    });
  }

}
